import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { slideInAnimation } from '../../animations';

@Component({
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  animations: [
    slideInAnimation
  ]
})

export class PublicLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    $('body').addClass('public-layout');
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

}
